import type { LocationCoordinatesType } from "@sellar-io/api-v2/types";
import { skipToken, useQuery } from "@tanstack/react-query";
import type { UserCreateResponseType } from "@sellar-io/api-v2/types";
import {
  ApiV2RequestScope,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";

export const useLocationFromPostcode = (
  unAuthorisedUserPostcode: string | undefined,
  user: UserCreateResponseType | null,
  unAuthorisedUserLocation: { lat: number; lng: number } | undefined,
) => {
  return useQuery({
    queryKey: ["locationFromPostcode", unAuthorisedUserPostcode],
    // This legacy endpoint returns the DTO directly, without a data envelope.
    queryFn: unAuthorisedUserPostcode
      ? ({ signal }) =>
          apiV2Request({
            scope: ApiV2RequestScope.Public,
            method: "get",
            path: "location/postcode",
            params: { postcode: unAuthorisedUserPostcode },
            signal,
          }).then((response) => response.data as LocationCoordinatesType)
      : skipToken,
    ...getDefaultQueryOptionsV2<LocationCoordinatesType>({
      context: { scope: "public" },
      options: {
        enabled:
          !!unAuthorisedUserPostcode && !user && !unAuthorisedUserLocation,
      },
    }),
  });
};
